import script from "./BaseButtonGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseButtonGroup.vue?vue&type=script&setup=true&lang=js"

import "./BaseButtonGroup.vue?vue&type=style&index=0&id=63cfbaee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63cfbaee"]])

export default __exports__